<template>
  <svg
    width="84"
    height="84"
    viewBox="0 0 84 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M83.8125 23.8125C83.8125 24 83.8125 24 83.625 24H45V0H67.5C70.125 0 72.375 1.6875 73.3125 4.125L83.8125 23.8125ZM39 24H0.1875C0 24 0 24 0 23.8125L10.5 4.125C11.4375 1.6875 13.6875 0 16.3125 0H39V24ZM0 30H84V75C84 80.0625 79.875 84 75 84H9C3.9375 84 0 80.0625 0 75V30ZM57.1875 58.125C61.125 54.1875 60.75 47.8125 56.4375 44.0625C52.5 41.0625 46.875 41.625 43.3125 45L42 46.5L40.5 45C36.9375 41.625 31.3125 41.0625 27.375 44.0625C23.0625 47.8125 22.6875 54.1875 26.625 58.125L40.3125 71.4375C41.25 72.375 42.5625 72.375 43.5 71.4375L57.1875 58.125Z"
      :fill="props.fill"
    />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  fill: {
    type: String,
    default: '#8ABFDE',
  },
});
</script>
